type DocumentTitleProps = {
    title: string;
};

export function DocumentTitle({ title }: DocumentTitleProps) {
    if (!title) {
        return null;
    }

    return <title>{title}</title>;
}
